import React from 'react';

export interface BetPosition {
    id: string;
    code: string;
}

export const betLocation = {
    OFFER: 'betOverview',
    DETAIL: 'betDetail',
    DEFAULT_POSITION: {
        id: '0',
        code: 'DEFAULT_POSITION'
    },
    HP_TOP5_PICK: {
        id: '1.1',
        code: 'HP_TOP5_PICK'
    },
    HP_TOP5_BUTTON: {
        id: '1.6',
        code: 'HP_TOP5_BUTTON'
    },
    HP_SUPERCHANCE: {
        id: '1.2',
        code: 'HP_SUPERCHANCE'
    },
    HP_SUPEROFFER: {
        id: '1.3',
        code: 'HP_SUPEROFFER'
    },
    HP_10NAJ_PICK: {
        id: '1.4',
        code: 'HP_10NAJ_PICK'
    },
    HP_10NAJ_BUTTON: {
        id: '1.5',
        code: 'HP_10NAJ_BUTTON'
    },
    HP_BETBOOK: {
        id: '1.7',
        code: 'HP_BETBOOK'
    },
    HP_TOP_FOOTBALL: {
        id: '1.11',
        code: 'HP_TOP_FOOTBALL'
    },
    HP_TOP_HOCKEY: {
        id: '1.12',
        code: 'HP_TOP_HOCKEY'
    },
    HP_TOP_TENNIS: {
        id: '1.13',
        code: 'HP_TOP_TENNIS'
    },
    HP_TOP_TOURNAMENT_1: {
        id: '1.14.1',
        code: 'HP_TOP_TOURNAMENT_1'
    },
    HP_TOP_TOURNAMENT_2: {
        id: '1.14.2',
        code: 'HP_TOP_TOURNAMENT_2'
    },
    HP_TOP_TOURNAMENT_3: {
        id: '1.14.3',
        code: 'HP_TOP_TOURNAMENT_3'
    },
    HP_TOP_TOURNAMENT_4: {
        id: '1.14.4',
        code: 'HP_TOP_TOURNAMENT_4'
    },
    HP_TOP_TOURNAMENT_5: {
        id: '1.14.5',
        code: 'HP_TOP_TOURNAMENT_5'
    },
    HP_10NAJ_PREMATCH: {
        id: '1.15',
        code: 'HP_10NAJ_PREMATCH'
    },
    HP_10NAJ_LIVE: {
        id: '1.16',
        code: 'HP_10NAJ_LIVE'
    },
    HP_SEARCH: {
        id: '1.8',
        code: 'HP_SEARCH'
    },
    HP_BANNER: {
        id: '1.9',
        code: 'HP_BANNER'
    },
    KURZY_OVERVIEW_SUPEROFFER: {
        id: '2.1.1',
        code: 'KURZY_OVERVIEW_SUPEROFFER'
    },
    KURZY_OVERVIEW_SUPERCHANCE: {
        id: '2.1.2',
        code: 'KURZY_OVERVIEW_SUPERCHANCE'
    },
    KURZY_OVERVIEW_LIVE: {
        id: '2.1.3',
        code: 'KURZY_OVERVIEW_LIVE'
    },
    KURZY_OVERVIEW_PREMATCH: {
        id: '2.1.4',
        code: 'KURZY_OVERVIEW_PREMATCH'
    },
    KURZY_DETAIL_PREMATCH: {
        id: '2.2.1',
        code: 'KURZY_DETAIL_PREMATCH'
    },
    KURZY_DETAIL_LIVE: {
        id: '2.2.2',
        code: 'KURZY_DETAIL_LIVE'
    },
    KURZY_DETAIL_ANALYSIS: {
        id: '2.2.4.1',
        code: 'KURZY_DETAIL_ANALYSIS'
    },
    KURZY_DETAIL_ANALYSIS_OSTATNI_TIPUJU: {
        id: '2.2.4.2',
        code: 'KURZY_DETAIL_ANALYSIS_OSTATNI_TIPUJU'
    },
    KURZY_DETAIL_OSTATNI_TIPUJU_PREMATCH: {
        id: '2.2.5.1',
        code: 'KURZY_DETAIL_OSTATNI_TIPUJU_PREMATCH'
    },
    KURZY_DETAIL_OSTATNI_TIPUJU_LIVE: {
        id: '2.2.5.2',
        code: 'KURZY_DETAIL_OSTATNI_TIPUJU_LIVE'
    },
    KURZY_DETAIL_TICKET_LIST: {
        id: '2.2.6',
        code: 'KURZY_DETAIL_TICKET_LIST'
    },
    KURZY_CHAT_TICKET: {
        id: '2.3.1',
        code: 'KURZY_CHAT_TICKET'
    },
    OLDLIVE_OVERVIEW: {
        id: '3.1.1',
        code: 'OLDLIVE_OVERVIEW'
    },
    OLDLIVE_DETAIL: {
        id: '3.2.1',
        code: 'OLDLIVE_DETAIL'
    },
    OLDLIVE_DETAIL_OSTATNI_TIPUJU: {
        id: '3.2.2',
        code: 'OLDLIVE_DETAIL_OSTATNI_TIPUJU'
    },
    OLDLIVE_CHAT_TICKET: {
        id: '3.4.1',
        code: 'OLDLIVE_CHAT_TICKET'
    },
    TURBOLIVE_OVERVIEW_COL1: {
        id: '4.1.1.1',
        code: 'TURBOLIVE_OVERVIEW_COL1'
    },
    TURBOLIVE_OVERVIEW_COL2: {
        id: '4.1.1.2',
        code: 'TURBOLIVE_OVERVIEW_COL2'
    },
    TURBOLIVE_OVERVIEW_COL3: {
        id: '4.1.1.3',
        code: 'TURBOLIVE_OVERVIEW_COL3'
    },
    TURBOLIVE_OVERVIEW_COL4: {
        id: '4.1.1.4',
        code: 'TURBOLIVE_OVERVIEW_COL4'
    },
    TURBOLIVE_OVERVIEW_COL5: {
        id: '4.1.1.5',
        code: 'TURBOLIVE_OVERVIEW_COL5'
    },
    TURBOLIVE_OVERVIEW_COL6: {
        id: '4.1.1.6',
        code: 'TURBOLIVE_OVERVIEW_COL6'
    },
    TURBOLIVE_OVERVIEW_COL7: {
        id: '4.1.1.7',
        code: 'TURBOLIVE_OVERVIEW_COL7'
    },
    TURBOLIVE_OVERVIEW_COL8: {
        id: '4.1.1.8',
        code: 'TURBOLIVE_OVERVIEW_COL8'
    },
    TURBOLIVE_OVERVIEW_TICKET_LIST: {
        id: '4.1.2',
        code: 'TURBOLIVE_OVERVIEW_TICKET_LIST'
    },
    TURBOLIVE_DETAIL: {
        id: '4.3.1',
        code: 'TURBOLIVE_DETAIL'
    },
    TURBOLIVE_DETAIL_OSTATNI_TIPUJU: {
        id: '4.3.2',
        code: 'TURBOLIVE_DETAIL_OSTATNI_TIPUJU'
    },
    TURBOLIVE_DETAIL_ANALYSIS: {
        id: '4.3.3.1',
        code: 'TURBOLIVE_DETAIL_ANALYSIS'
    },
    TURBOLIVE_DETAIL_ANALYSIS_OSTATNI_TIPUJU: {
        id: '4.3.3.2',
        code: 'TURBOLIVE_DETAIL_ANALYSIS_OSTATNI_TIPUJU'
    },
    TURBOLIVE_DETAIL_MATCH_LIST: {
        id: '4.3.4',
        code: 'TURBOLIVE_DETAIL_MATCH_LIST'
    },
    TURBOLIVE_CHAT_TICKET: {
        id: '4.4.1',
        code: 'TURBOLIVE_CHAT_TICKET'
    },
    TURBOLIVE_TICKET_LIST: {
        id: '4.5.1',
        code: 'TURBOLIVE_TICKET_LIST'
    },
    COMMUNITY_ANALYSIS_DETAIL: {
        id: '5.1',
        code: 'BETBOOK_ANALYSIS_DETAIL'
    },
    BETBOOK_ANALYSIS_OSTATNI_TIPUJU: {
        id: '5.7',
        code: 'BETBOOK_ANALYSIS_OSTATNI_TIPUJU'
    },
    COMMUNITY_TICKET_DETAIL: {
        id: '5.2',
        code: 'BETBOOK_TICKET_DETAIL'
    },
    BETBOOK_CHAT_TICKET: {
        id: '5.3',
        code: 'BETBOOK_CHAT_TICKET'
    },
    BETBOOK_OVERVIEW: {
        id: '5.4',
        code: 'BETBOOK_OVERVIEW'
    },
    BETBOOK_OVERVIEW_ANALYSIS: {
        id: '5.5',
        code: 'BETBOOK_OVERVIEW_ANALYSIS'
    },
    BETBOOK_OVERVIEW_TICKETS: {
        id: '5.6',
        code: 'BETBOOK_OVERVIEW_TICKETS'
    },
    BETBOOK_TOP20: {
        id: '5.8',
        code: 'BETBOOK_TOP20'
    },
    THIRD_PARTY_LIVE_BANNER: {
        id: '6.2',
        code: '3RD_LIVE_BANNER'
    },
    NIKETV_DETAIL_PREMATCH: {
        id: '7.1',
        code: 'NIKETV_DETAIL_PREMATCH'
    },
    NIKETV_DETAIL_LIVE: {
        id: '7.2',
        code: 'NIKETV_DETAIL_LIVE'
    },
    NTV_STREAM_DETAIL: {
        id: '7.3',
        code: 'NTV_STREAM_DETAIL'
    },
    NIKETV_BANNERS: {
        id: '7.4',
        code: 'NIKETV_BANNERS'
    },
    NTV_DETAIL_OSTATNI_TIPUJU: {
        id: '7.6',
        code: 'NIKETV_BANNERS'
    },
    TICKET_DETAIL: {
        id: '8.1',
        code: 'TICKET_DETAIL'
    },
    TICKET_LIST: {
        id: '8.2',
        code: 'TICKET_LIST'
    },
    SAVED_TICKETS_LIST: {
        id: '8.3',
        code: 'SAVED_TICKETS_LIST'
    },
    TICKET_INSPIRATIONS: {
        id: '8.4',
        code: 'TICKET_INSPIRATIONS'
    },
    BETSLIP_EDITOR_CHANGE_PICK: {
        id: '9.1',
        code: 'BETSLIP_EDITOR_CHANGE_PICK'
    },
    TOURNAMENTS_TICKET_LIST: {
        id: '10.1',
        code: 'TOURNAMENTS_TICKET_LIST'
    },
    PROMO_PAGE: {
        id: '12.1',
        code: 'PROMO_PAGE'
    }
} as const;

export type BetLocactionSectionOptions = typeof betLocation[keyof typeof betLocation];

export const getPrematchLocation = (boxId, boxStore, suggestionData) => {
    if (suggestionData) {
        return betLocation.HP_SEARCH;
    }
    if (boxStore === 'homeStore') {
        switch (boxId) {
            case 'top5':
                return betLocation.HP_TOP5_PICK;
            case 'superoffer':
                return betLocation.HP_SUPEROFFER;
            case 'naj10':
                return betLocation.HP_10NAJ_PICK;
            case 'superchance':
                return betLocation.HP_SUPERCHANCE;
            default:
                return betLocation.KURZY_OVERVIEW_PREMATCH;
        }
    }
    switch (boxId) {
        case 'superoffer':
            return betLocation.KURZY_OVERVIEW_SUPEROFFER;
        case 'superchance':
            return betLocation.KURZY_OVERVIEW_SUPERCHANCE;
        default:
            return betLocation.KURZY_OVERVIEW_PREMATCH;
    }
};

export const getModalLocation = locationId => {
    switch (locationId) {
        case betLocation.KURZY_DETAIL_ANALYSIS.id:
            return betLocation.KURZY_DETAIL_ANALYSIS_OSTATNI_TIPUJU;
        case betLocation.TURBOLIVE_DETAIL_OSTATNI_TIPUJU.id:
            return betLocation.TURBOLIVE_DETAIL_ANALYSIS_OSTATNI_TIPUJU;
        default:
            return betLocation.BETBOOK_ANALYSIS_OSTATNI_TIPUJU;
    }
};

const BetLocationContext = React.createContext<{
    betLocationSection: BetLocactionSectionOptions | null;
}>({
    betLocationSection: null
});

export default BetLocationContext;
